import * as React from 'react';

/** @deprecated Work with your designer to replace with one of the current illustrations (https://lens.loom.dev/illustrations/illustration-set). */
function IllustrationRoadmap(props) {
  return (
    <svg
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M100 100H0V0h100v100zM10 90h80V10H10v80z" fill="currentColor" />
      <path
        d="M50.008 39.806L80 54v-9.806L50.008 30 20 44.194V54l30.008-14.194zM80 20H20v10h60V20z"
        fill="currentColor"
      />
    </svg>
  );
}

export default IllustrationRoadmap;
